import InfiniteScroll from 'react-infinite-scroll-component';

import getHeightForLayoutType from './get-height-for-layout';
import CaptivateImageGridUI from '../CaptivateImageGridUI';
import CaptivateAllImageHeader from '../CaptivateAllImageModal/CaptivateAllImageHeader';
import * as S from '../CaptivativeImagesGrid.styles';

const chunkArray = (data, chunkSizes) => {
  let chunkedData = [];
  let chunkIndex = 0;

  data.flat().forEach((item, index) => {
    item.imageNo = index + 1;
  });

  data.forEach(item => {
    for (let i = 0; i < item.length; i += chunkSizes[chunkIndex], chunkIndex++) {
      if (chunkIndex >= chunkSizes.length) chunkIndex = 0;
      chunkedData.push(item.slice(i, i + chunkSizes[chunkIndex]));
    }
  });

  return chunkedData;
};

const CaptivateImageGrid = ({
  imageGridDataListArrays = [],
  mode = 'fixed',
  title = '',
  totalCount = 0,
  maxImageGridType = 1,
  chunkSizesArray = [1],
  variations = true,
  showHeader = true,
  updateMediaDetails = () => {},
  updateCarouselState = () => {},
}) => {
  const imageGridDataList = imageGridDataListArrays.flat();
  if (!imageGridDataList.length) return null;

  const maxGridType = Math.min(maxImageGridType, Math.min(8, imageGridDataList.length));
  const chunkSizes = mode === 'fixed' ? [maxGridType] : chunkSizesArray;
  const chunkedImagesData = chunkArray(imageGridDataListArrays, chunkSizes);
  const variationConfig = {};

  const elementsHeightArray = chunkedImagesData?.map(chunk => {
    const variation = variations && variationConfig[chunk.length];
    return getHeightForLayoutType(chunk.length, variation);
  });

  return (
    <>
      {showHeader && (
        <CaptivateAllImageHeader
          title={title}
          totalCount={totalCount}
          categoryOverviewData={imageGridDataListArrays[0]}
          headerType="taggedMedia"
          updateMediaDetails={updateMediaDetails}
        />
      )}
      <S.CaptivateGridContainer>
        {chunkedImagesData.length === elementsHeightArray.length && (
          <InfiniteScroll
            dataLength={chunkedImagesData.length}
            next={() => {}}
            hasMore={false}
            loader={<h4>Loading...</h4>}
            height={614}
          >
            {chunkedImagesData.map((imgListChunk, index) => {
              variationConfig[imgListChunk.length] =
                (variationConfig[imgListChunk.length] || 0) + 1;
              return (
                <CaptivateImageGridUI
                  type={imgListChunk.length}
                  dataList={imgListChunk}
                  variation={variations && variationConfig[imgListChunk.length]}
                  key={index}
                  updateCarouselState={updateCarouselState}
                />
              );
            })}
          </InfiniteScroll>
        )}
      </S.CaptivateGridContainer>
    </>
  );
};

export default CaptivateImageGrid;
